import { useState } from 'react';
import AdminBikes    from './AdminBikes';
import AdminBookings from './AdminBookings';
import AdminPromos   from './AdminPromos';
import AdminUsers    from './AdminUsers';
import AdminStats    from './AdminStats';
import styles from './AdminDashboard.module.css';

const TABS = [
  { key: 'stats',    label: '📊 Overview' },
  { key: 'bikes',    label: '🚲 Bikes' },
  { key: 'bookings', label: '📋 Bookings' },
  { key: 'promos',   label: '🏷 Promos' },
  { key: 'users',    label: '👥 Users' },
];

const AdminDashboard = () => {
  const [tab, setTab] = useState('stats');

  return (
    <div className="container">
      <h1 className={styles.title}>Admin dashboard</h1>
      <div className={styles.tabs}>
        {TABS.map(t => (
          <button
            key={t.key}
            className={`${styles.tab} ${tab === t.key ? styles.active : ''}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className={styles.panel}>
        {tab === 'stats'    && <AdminStats />}
        {tab === 'bikes'    && <AdminBikes />}
        {tab === 'bookings' && <AdminBookings />}
        {tab === 'promos'   && <AdminPromos />}
        {tab === 'users'    && <AdminUsers />}
      </div>
    </div>
  );
};

export default AdminDashboard;
